export default __webpack_public_path__ + "static/media/logoBmoonDark.5af3fce0.png";